import { changeView } from './changeView';
export function previousView() {
  return function (dispatch, getState, context) {
    var logger = context.logger;
    var _getState = getState(),
      data = _getState.view.data;
    if (!data || !data.prevView) {
      logger.warning('Failed to switch previous view');
      return;
    }
    dispatch(changeView(data.prevView, data.prevData));
  };
}